import { OperationRequest } from '../operations/operation-request';
import { Strategy } from './abstract-strategy';

export class ThanksStrat extends Strategy {
  public hasCondition(request: OperationRequest): boolean {
    const hasNoError = !request.hasError;
    if (request.hasFinishCircuit && hasNoError) {
      return true;
    }
    return false;
  }

  public setStrategy(request?: OperationRequest): void {
    this.pathToGo = 'thanks';
  }
}
